"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("@fluentui/react");
require("./LoadingSpinner.scss");
var LoadingSpinner = function (props) {
    var messageLabel = props.messageLabel;
    return (React.createElement("div", { className: "loading_panel" },
        React.createElement("div", { className: "content" },
            React.createElement(react_1.Spinner, { size: react_1.SpinnerSize.large, ariaLive: "assertive", label: messageLabel }))));
};
exports.default = LoadingSpinner;
//# sourceMappingURL=LoadingSpinner.js.map